/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/**
 * Provides a multi language string library
 * @param {string} language
 * Langauge to use generaly. Default is <i>de</i>
 * @returns {Lng}
 */
function Lng(language) {
  if (!this instanceof Lng) return new Lng();

  var that = this;

  this.get = get;
  this._lib = lib();
  this._languageSelected;

  if (this._lib[language] !== undefined) {
    this._languageSelected = language;
  } else {
    this._languageSelected = "de";
    //console.warn(`Language ${language} not found. Useing "de" as default.`);
  }

  function get(key) {
    var val = that._lib[that._languageSelected][key];
    if (val === undefined) {
      //console.info(`Lng could not resolve ${key} for language ${that._languageSelected}`);
      return key;
    }
    return val;
  }

  function lib() {
    /*
         -- some patterns --

         - Numbers are for http errors

         - ${schemaKey}

         - ${schemaKey}s
         Plural of schema label

         - ${schemaKey}_${httpStatusCode}

         - ${schemaKey}_${attribute}

         - validation_${rule}
         Match with parseValidationError().parseLine()

         */

        return {
            de: {
                'unknownError': 'Unbekannter Fehler',
                'network-err': 'Fehler in der Kommunikation mit dem Server.',
                '500': 'Unbekannter Serverfehler',
                '400': 'Fehlerhafte Netzwerkanfrage.',
                '402': 'Ihr Abonnement deckt diese Leistung nicht ab.',
                '403': 'Sie haben keine Berechtigung diese Aktion auszuführen. Wenden Sie sich an Ihren Vorgesetzten oder an einen Support-Mitarbeiter.',
                '404': 'Kein entsprechendes Objekt gefunden.',
                '409': 'Aktion kann wegen eines dadurch entstehenden Konfliktes nicht ausgeführt werden.',
                '410': 'Objekt wurde deaktiviert und kann nicht mehr genutzt werden.',

                'true': 'Ja',
                'false': 'Nein',
                'ok': 'Ok',

                // -- weekdays --
                'monday': 'Montag',
                'tuesday': 'Dienstag',
                'wednesday': 'Mittwoch',
                'thursday': 'Donnerstag',
                'friday': 'Freitag',
                'saturday': 'Samstag',
                'sunday': 'Sonntag',

                // -- schema --
                'active': 'Aktiv',
                'active-employee': 'Aktiv',
                'employee-active': 'Aktiv',
                'general-information': 'Allgemeine Informationen',
                'partnerGroup': 'Dienstleister',
                'partnerGroups': 'Dienstleister',
                'partner': 'Partner',
                'partners': 'Partner',
                'user': 'Benutzer',
                'users': 'Benutzer',
                'contract': 'Vertrag',
                'contracts': 'Verträge',
                'contractBlueprint': 'Vertragsvorlage',
                'contractBlueprints': 'Vertragsvorlagen',
                'deliveryArea': 'Zustellgebiet',
                'deliveryAreas': 'Zustellgebiete',
                'notificationMail': 'Benachrichtigungs-E-Mail',
                'notificationMail_fromadress': 'From-Adresse',
                'notificationMail_hostname': 'Hostname',
                'notificationMail_port': 'Port',
                'notificationMail_username': 'Benutzername',
                'notificationMail_password': 'Passwort',
                'notificationMail_active': 'Aktiv',
                'notificationMail_auth': 'Authentifizierungs-Typ',
                'notificationMail_smtp_authenfitication': 'SMTP-Authentifizierung',
                'notificationMail_smtpAuthenfitication' : 'SMTP-Authentifizierung',
                'notificationMails': 'Benachrichtigungs-E-Mails',
                'form': 'Formular',
                'forms': 'Formulare',
                'print-epaper': 'Print / E-Paper',
                'formExportCsv': 'CSV-Konfiguration',
                'formExportCsv_csvEncoding': 'CSV-Kodierung',
                'form_formExportCsv': 'CSV-Konfiguration',
                'formExportCsvs': 'CSV-Konfigurationen',
                'formExportXml': 'XML-Konfiguration',
                'form_formExportXml': 'XML-Konfiguration',
                'formExportXmls': 'XML-Konfigurationen',
                'formExportPdf': 'PDF-Konfiguration',
                'form_formExportPdf': 'PDF-Konfiguration',
                'formExportPdfs': 'PDF-Konfiguration',
                'employee': 'Promoter',
                'employees': 'Promoter',
                'customer': 'Abonnement',
                'customers': 'Abonnements',
                'customerTodays': 'Tageslisten',
                'location': 'Standort',
                'startDate': 'von',
                'endDate': 'bis',
                'text': 'Volltextsuche',
                'date': 'Datum',
                'time': 'Uhrzeit',
                'data': 'Daten',
                'export': 'Exportieren',
                'number': '#',
                'surname': 'Nachname',
                'prename': 'Vorname',
                'formExport': 'CSV Vorlage',
                'pdfFormExport': 'PDF Vorlage',
                'xmlFormExport': 'XML Vorlage',
                'locations': 'Standorte',
                'appLicence': 'Geräte-Lizenz',
                'appLicences': 'Geräte-Lizenzen',
                'user_error_partnerGroup-required': 'Es muss mindestens ein Dienstleister hinzugefügt werden',
                'user_login': 'Benutzername',
                'user_password': 'Passwort',
                'user_active': 'Aktiv',
                'user_profitCenter': 'Profit Center',
                'user_admin': 'Administrator',
                'user_managePartner': 'Support-Mitarbeiter',
                'user_partnerGroupManager': 'Verwaltet Dienstleister',
                'user_dashboardUser': 'Dashboard-Benutzer',
                'emailConfig': 'Email-Konfiguration',
                'partnerGroup_name': 'Name',
                'partnerGroup_active': 'Aktiv',
                'partnerGroup_partner': 'Partner',
                'partnerGroup_invisible': 'Direktkunde',
                'partnerGroup_manager': 'Verantwortlicher Mitarbeiter',
                'partnerGroup_currentContract': 'Aktueller Vertrag',
                'partnerGroup_contract': 'Verträge',
                'partnerGroup_appLicence': 'Geräte-Lizenzen',
                'partnerGroup_user': 'Benutzer',

                'partner_name': 'Name',
                'partner_adress': 'Adresse',
                'partner_phone': 'Telefonnummer',
                'partner_mail': 'E-Mail',
                'partner_barcodeExpression': 'Barcode Ausdruck',
                'partner_exportNameing': 'Dateibezeichnung Export',
                'partner_partnerLogo': 'Logo',
                'partner_streetSchema': 'Straßenverzeichnis',
                'partner_zipEdition': 'Zuordnung PLZ zu Ausgabe',
                'partner_deliveryArea': 'Zustellgebiet (durch , getrennt)',
                'partner_active': 'Aktiv',
                'partner_autodeleteDefault': 'Automatische Löschung der Abonnements nach x Monaten (-1: keine Löschung)',
                'partner_workWithoutLocation': 'Arbeiten ohne Standortangabe möglich',
                'partner_employeePartner': 'Promoter',
                'partner_locationPartner': 'Standorte',
                'partner_formPartner': 'Formulare',
                'partner_partnerGroup': 'Dienstleister',
                'partner_user': 'Benutzer',
                'partner_weeklyExportMails': 'Export-Empfänger',
                'partner_readingSamplesPlanned': 'Geplante Leseproben pro Woche',
                'partner_affiliates': 'Zusatz-Bestellungen',
                'partner_salesManager': 'Verkaufsleiter',
                'contract_409': 'Vertrag konnte aufgrund einer zeitlichen Überschneidung nicht erstellt werden.',
                'contract_411': 'Es wurde keine valide Vetragsvorlage ausgewählt',
                'contract_licenceContingent': 'Anzahl der Lizenzen',
                'contract_partnerContingent': 'Mögliche Anzahl der Partner',
                'contract_cost': 'Monatliche Kosten',
                'contract_duration': 'Vertragslaufzeit in Monaten',
                'contract_periodOfNotice': 'Kündigungsfrist in Monaten',
                'contract_startDate': 'Vertragsbeginn',
                'contract_endDate': 'Vertragsende',
                'contract_contractBlueprint': 'Vertragsvorlage',
                'contract_autoExtend': 'Automatische Verlängerung um x Monate',
                'contract_canceled': 'Vertrag mit sofortiger Wirkung annulliert',
                'contract_partnerGroup': 'Dienstleister',
                'contract_custom': 'Bitte wählen Sie einen Vertragsbeginn aus.',
                'contractBlueprint_name': 'Name',
                'contractBlueprint_active': 'Aktiv',
                'contractBlueprint_licenceContingent': 'Anzahl der Lizenzen',
                'contractBlueprint_partnerContingent': 'Mögliche Anzahl der Partner',
                'contractBlueprint_cost': 'Monatliche Kosten',
                'contractBlueprint_duration': 'Vertragslaufzeit in Monaten',
                'contractBlueprint_periodOfNotice': 'Kündigungsfrist in Monaten',
                'contractBlueprint_autoExtend': 'Automatische Verlängerung um x Monate',
                'contractBlueprint_contract': 'Abgeschlossene Verträge',
                'affiliates_form': 'Formular Name',
                'affiliates_Formular': 'Formular Name',

                //DASHBOARD
                'dashboard': 'Dashboard',
                'dashboards': 'Dashboard',
                'dashboard-no-entries': 'Keine Einträge',
                'dashboard-choose': 'Auswählen',
                'dashboard-all': 'Alle',
                'dashboard-from': 'von',
                'dashboard-per': 'je',
                'dashboard-per-day': 'pro Tag',
                'dashboard-per-month': 'pro Monat',
                'dashboard-per-year': 'pro Jahr',
                'dashboard-customers': 'Abschlüsse',
                'dashboard-last-customer': 'Letzter Abschluss',
                'dashboard-no-customers': 'Keine Abschlüsse in diesem Zeitraum',
                'dashboard-per-day-hour': 'pro Tag und Stunde',

                //AUTOMATIC EXPORT
                'automaticExport': 'Automatischer Export',
                'automaticExports': 'Automatische Exports',
                'autoExport': 'Export',
                'autoExports': 'Exports',
                'autoExportss': 'Exports',
                'automaticExport_name': 'Exportbezeichnung',
                'automaticExport_csvConfig': 'CSV-Konfiguration',
                'automaticExport_pdfConfig': 'PDF-Konfiguration',
                'automaticExport_xmlConfig': 'XML-Konfiguration',
                'automaticExport_exportConfig': 'Export-Konfiguration',
                'automaticExport_active': 'Aktiv',
                'automaticExport_partner': 'Partner',
                'automaticExport_ftpConfig': 'FTP-Konfiguration',
                'automaticExport_smtpConfig': 'E-Mail-Konfiguration',
                'automaticExport_dateConfig': 'Datums-Konfiguration',
                'automaticExport_schema': 'Konfigurieren',

                'weekly': 'Wöchentlich',
                'twoweekly': 'Zweiwöchentlich',
                'monthly': 'Monatlich (30 Tage)',

                //MAIL
                'mail': 'E-Mail',
                'mails': 'E-Mails',

                //MAILCONTENT
                'mailContent': 'E-Mail-Nachricht',
                'mailContents': 'E-Mail-Nachrichten',
                'mailContent_subject': 'Betreff',
                'mailContent_htmlBody': 'Mail-Template',
                'mailContent_mailFields': 'Variablen',
                'mailContent_mailAttachment': 'Anhang',

                //EMPLOYEE
                'employee_error_partner-required': 'Geben Sie einen Partner an',
                'employee_name': 'Name',
                'employee_login': 'Login',
                'employee_password': 'Passwort',
                'employee_phone': 'Telefonnummer',
                'employee_mail': 'E-Mail',
                'employee_adress': 'Adresse',
                'employee_birthdate': 'Geburtsdatum',
                'employee_active': 'Aktiv',
                'employee_lastLogin': 'Letzter Login',
                'employee_employeePartner': 'Arbeitet für Partner',
                'employeePartner_number': 'Mitarbeiternummer',
                'employeePartner_active': 'Aktiv',
                'employeePartner_partner': 'Dienstleister',
                'employeePartner_employee': 'Mitarbeiter',
                'location_error_partner-required': 'Geben Sie einen Partner an',
                'location_name': 'Bezeichnung',
                'location_adress': 'Adresse',
                'location_active': 'Aktiv',
                'location_activeUntil': 'Aktiv bis',
                'location_coordinates': 'Koordinaten (lng, lat)',
                'location_private': 'Privater Standort',
                'location_locationPartner': 'Partner',
                'locationPartner': 'Standort',
                'locationPartner_active': 'Aktiv',
                'locationPartner_masNumber': 'Marketingnummer',
                'locationPartner_locationname': 'Standortbezeichnung',
                'locationPartner_adress': 'Adresse',
                'locationPartner_useableFrom': 'Verwendbar ab',
                'locationPartner_useableUntil': 'Verwendbar bis',
                'locationPartner_location': 'Standort',
                'locationPartner_customers': 'Abonnements',
                'locationPartner_partner': 'Partner',
                'form_error_partner-required': 'Geben Sie einen Partner an',
                'form_name': 'Bezeichnung',
                'form_template': 'Vorlage',
                'form_schema': 'Struktur',
                'form_active': 'Aktiv',
                'form_productive': 'Produktiv',
                'form_formPartner': 'Partner',
                'form_partner': 'Partner',
                'form_activeFrom': 'Aktiv von',
                'form_activeTo': 'Aktiv bis',
                'form_category': 'Kategorie',
                'form_isAffiliate': 'Bonus-Angebot',
                'formPartner': 'Formular',
                'formPartner_active': 'Aktiv',
                'formPartner_useable': 'Verwendbar',
                'formPartner_useableFrom': 'Verwendbar ab',
                'formPartner_useableUntil': 'Verwendbar bis',
                'formPartner_autoDelete': 'Automatische Löschung der Abonnements nach x Monaten (-1: keine Löschung)',
                'formPartner_form': 'Formular',
                'formPartner_partner': 'Partner',
                'formPartner_formExportCsv': 'CSV-Konfiguration',
                'formPartner_formExportXml': 'XML-Konfiguration',
                'formPartner_notificationMail': 'Benachrichtigungs-E-Mail',
                'formPartner_customer': 'Abonnements',
                'appLicence_key': 'Key',
                'appLicence_deviceName': 'Gerätename',
                'appLicence_lastActivity': 'Zuletzt aktiv',
                'appLicence_partnerGroup': 'Dienstleister',
                'appLicence_isFree': 'Löschen',
                'customer_locationPartner': 'Standort',
                'customer_formPartner': 'Formular',
                'customer_employeePartner': 'Promoter',
                'formExportCsv_428': 'Wählen Sie einen Partner aus', //should be newer shown. Just in case for better reporting
                'formExportCsv_name': 'Bezeichnung',
                'formExportCsv_config': 'Konfiguration',
                'formExportCsv_formPartner': 'Formular',
                'formExportCsv_form': 'Formular',
                'formExportXml_name': 'Bezeichnung',
                'formExportXml_config': 'Konfiguration',
                'formExportXml_formPartner': 'Formular',
                'formExportXml_form': 'Formular',
                'formExportPdf_name': 'Bezeichnung',
                'formExportPdf_config': 'Konfiguration',
                'formExportPdf_formPartner': 'Formular',
                'formExportPdf_form': 'Formular',
                'longitude' : 'Längengrad',
                'location_longitude' : 'Längengrad',
                'latitude' : "Breitengrad",
                'location_latitude' : 'Breitengrad',

                // -- partner --
                'partner_402': 'Für den Dienstleister ist kein aktiver Vertrag hinterlegt.',
                'partner_401': 'Für den Dienstleister ist die maximale Anzahl an Partnern erreicht.',
                'partner_400': 'Bitte geben Sie für die Location ',

                // -- partnerGroup --
                'partnerGroup_411': 'Maximale Anzahl an Lizenzen erreicht',
                'partnerGroup_412': 'Bitte verwenden Sie einen validen Mitarbeiter',
                'partnerGroup_unique': 'Ein Dienstleister mit dem Namen existiert bereits',

                // -- user --
                'user_unique': 'Ein Benutzer mit dem Login existiert bereits',

                // -- employee --
                'employee_unique': 'Ein Promoter mit dem Login existiert bereits',
                'employee_402': 'Ein Promoter mit dem Login existiert bereits',
                'employee_custom': 'Es ist ein Fehler aufgetreten',
                'employee_partner': 'Partner',

                // -- mailcontent --
                'mailAttachments': 'Mail-Anhänge',
                'mailAttachment_name': 'Mail-Anhang',
                'mailAttachment_mailContent': 'Mail-Anhang',

                // -- validation --
                'validation_required': 'Dies ist ein Pflichtfeld',
                'validation_minLength': 'Mindestlänge noch nicht erreicht',
                'validation_maxLength': 'Maximallänge überschritten',
                'validation_unique': 'Bereits in Verwendung',
                'validation_no-email': 'Um die Einstellung E-Paper verwenden zu können, müssen Sie ein Email-Feld hinzufügen und dieses als Kontaktadresse verwenden.',
                'validation_short_no-email': 'Sie müssen ein Email-Feld hinzufügen und dieses als Kontaktadresse verwenden.',
                'validation_json': 'JSON Fehlerhaft',
                'validation_reserved': 'Wort ist reserviert und kann nicht verwendet werden',

                // -- form --
                'form-title': 'Formular',
                'form-label': 'Ziehen Sie eine Vorlage hier hin um sie zur Form hinzuzufügen',
                'form-blueprints-title': 'Vorlagen',
                'form-preview-title': 'Vorschau',
                'form-preview-partnerInput': 'Formular aus der Sicht des Partners..',
                'form-error-valid': 'Einige Felder sind nicht korrekt ausgefüllt. Diese sind rot markiert.',
                'form-input-sign': 'Unterschrift',
                'form-input-address': 'Adresse',
                'form-input-default': 'Eingabefeld',
                'form-input-text': 'Text',
                'form-input-textArea': 'Textfeld',
                'form-input-textArea-height': 'Anzahl der Zeilen',
                'form-input-textArea-placeholder': 'Platzhalter',
                'form-input-image': 'Bild',
                'form-input-hr': 'Trennlinie',
                'form-attribute-titel': 'Titel',
                'form-attribute-label': 'Platzhalter',
                'form-attribute-name': 'Gruppenexportbezeichnung',
                'form-attribute-export': 'Export Bezeichnung',
                'form-attribute-required': 'Pflichtfeld',
                'form-attribute-one-more-week': '+ 1 Woche',
                'form-attribute-option': 'Wahlmöglichkeiten \n (durch ; getrennt)',
                'form-input-address-epaper': 'E-Paper',
                'form-input-address-epaper-print': 'E-Paper/Print',
                'form-input-address-epaper-everywhere': 'E-Paper überall verfügbar',
                'form-input-address-epaper-either-or': 'Nur einzeln Auswählbar',
                'form-input-address-print': 'Print',
                'form-input-address-autocomplete': 'Autovervollständigung',
                'form-input-address-checkPostalCode': 'Zustellgebiet überprüfen',
                'form-input-address-postalCode': 'PLZ',
                'form-input-address-city': 'Stadt',
                'form-input-address-street': 'Straße',
                'form-input-address-houseNumber': 'Hausnummer',
                'form-input-address-houseNumberExtra': 'Zusatz',
                'form-input-address-export-postal': 'Export Bezeichnung PLZ',
                'form-input-address-export-city': 'Export Bezeichnung Stadt',
                'form-input-address-export-street': 'Export Bezeichnung Straße',
                'form-input-address-export-street-number': 'Export Bezeichnung Hausnummer',
                'form-input-address-export-addition': 'Export Bezeichnung Zusatz',
                'form-input-address-export-print': 'Export Bezeichnung Print',
                'form-input-address-export-epaper': 'Export Bezeichnung E-Paper',
                'form-input-default-nInputs': 'Anzahl der Eingabefelder',
                'form-input-default-type': 'Typ',
                'form-input-default-text': 'Text',
                'form-input-default-number': 'Zahl',
                'form-input-default-email': 'E-Mail',
                'form-input-default-contact': 'Kontaktadresse',
                'form-input-default-date': 'Datum',
                'form-input-default-minlength': 'Mindesttlänge',
                'form-input-default-maxlength': 'Höchstlänge',
                'form-input-default-min': 'Min',
                'form-input-default-max': 'Max',
                'form-input-default-startdate': 'Startdatum',
                'form-input-default-startdatein': 'Startdatum in Tagen',
                'form-input-default-minage': 'Mindestalter',
                'form-input-default-enddate': 'Enddatum',
                'form-input-default-regex': 'Regulärer Ausdruck',
                'form-input-default-select': 'Dropdown',
                'form-input-default-tel': 'Telefon',
                'form-input-default-iban': 'IBAN',
                'form-input-default-autooptin': 'automatisches Opt-in',
                'form-input-default-emptySelect': 'Keine Leerauswahl',
                'form-input-text-checkbox': 'Checkbox hinzufügen',
                'form-input-text-checkboxNote': 'Falls ausgewählt müssen Name und Bezeichnung angegeben werden',
                'form-input-text-smalltext': 'Text verkürzen',
                'form-input-text-smalltextNote': 'Der Text wird auf die angegebenen Paragraphen verkürzt und kann dann ausgeklappt werden.',
                'form-input-text-textlength': 'Anzahl Paragraphen',
                'form-input-text-text': 'Hier Text eingeben',
                'form-input-image-partner': 'Logo des Partners',
                'form-input-hr-height': 'Höhe der Trennlinie',
                'form-input-tel': 'Telefon',
                'form-input-tel-vorwahl': 'mit Vorwahl',
                'form-input-tel-validation': 'Mobilfunknummer prüfen',
                'form-input-tel-autooptin': 'automatisches Opt-in',
                'form-input-tel-export-number': 'Export Bezeichnung Festnetz',
                'form-input-tel-export-number-area': 'Export Bezeichnung Festnetz Vorwahl',
                'form-input-tel-export-mobile': 'Export Bezeichnung Mobil',
                'form-input-tel-export-mobile-area': 'Export Bezeichnung Mobil Vorwahl',
                'form-submit': 'Formular Senden',
                'form-clear': 'Formular Leeren',
                'form-blueprint': 'Eingaben übertragen',
                'form-saved': 'Formular gespeichert!',
                'form-saved-error': 'Formular nicht gespeichert',
                'form-saved-offline': 'Formular offline gespeichert',
                'form-saved-permission-error': 'Die Berechtigung des Accounts konnte auf dem Server nicht überprüft werden. Das Formular wurde offline gespeichert und wird zu einem späteren Zeitpunkt versendet.',
                'form-saved_text-error': 'Die Daten konnten nicht erfolgreich gespeichert werden. Bitte versuchen Sie es erneut.',
                'form-saved_text': 'Die Daten wurden erfolgreich gespeichert.',
                'form-saved_text_apply_to_blueprint': 'Die Daten wurden erfolgreich gespeichert. Sie haben jetzt die Möglichkeit die Eingaben in ein anderes Formular für die Wiederverwendung zu übertragen oder das Formular zu leeren.',
                'form-no-areas-and-no-records': 'Das Straßenverzeichnis und die Zustellungsgebiete konnten nicht geladen werden',
                'form-no-delivery-areas': 'Die Zustellgebiete konnten nicht geladen werden',
                'form-no-street-records': 'Das Straßenverzeichnis konnte nicht geladen werden',
                // ---- formExportXXXBuilder ----
                'formExport-reserved_sign': 'Unterschrift',
                'formExport-reserved_empty': 'Leerspalten',
                'formExport-reserved_marketnumber': 'Marketingnummer',
                'formExport-reserved_image': 'Bild',
                'formExport-reserved_partnerGroup': 'Dienstleister',
                'formExport-reserved_partner': 'Partner',
                'formExport-reserved_form': 'Formular',
                'formExport-reserved_location': 'Standort',
				'formExport-reserved_employee': 'Promoter',
				'formExport-reserved_employeenumber': 'Mitarbeiternummer',
                'formExport-reserved_date': 'Aufnahmedatum / Aufnahmeuhrzeit',
                'formExport-reserved_time': 'Aufnahmeuhrzeit',
                'formExport-reserved_increasing_num': 'Aufsteigende Nummer',
                'formExport-reserved_iban': 'IBAN - JA / NEIN',
                'formExport-reserved_subscriptionType': 'Art des Abonnements (Print/E-Paper)',
                'formExport-reserved_zipEdition': 'Zuordnung von PLZ zu Ausgabe',
                'formExport-reserved_customerid': 'Kundenidentifikation',
                'formExport-reserved_customerid_intern': 'Interne Kundenidentifikation',
                'formExport-reserved_delivery_end': 'Lieferende',
                'formExport-reserved-keylabel_location': '$$location$$',
                'formExport-reserved-keylabel_employee': '$$promoter$$',
                'formExport-reserved-keylabel_employeenumber': '$$promoterID$$',
                'formExport-reserved-keylabel_date': '$$trackdate$$',
                'formExport-reserved-keylabel_time': '$$tracktime$$',
                'formExport-reserved-keylabel_customerid': '$$customerID$$',
                'formExport-reserved-keylabel_marketnumber': '$$marketnumber$$',
                'formExportXml-table-label': 'Export Bezeichnung',
                'formExportXml-table-keyLabel': 'Variable',
                'formExport-copy-variable': 'Die ausgewählte Variable wurde in die Zwischenablage kopiert: ',

                'formExport-placeholder': 'Bezeichnung in CSV',
                'formExport-placeholder_prefix': 'Spaltenpräfix',
                'formExport-placeholder_increasing_num': 'Starten bei:',
                'formExport-placeholder_iban': 'IBAN - JA / NEIN',
                'formExport-placeholder_empty': 'Anzahl der Leerspalten',
                'formExport-placeholder_epaper': 'Bezeichnung für E-Paper',
                'formExport-placeholder_print': 'Bezeichnung für Print',
                'csvform-export-configuration': 'Konfiguration',
                'csvform-export-preform': 'Vorgaben aus dem Formular',
                'xmlform-export-configuration': 'Konfiguration',
                'xmlform-export-preform': 'Vorgaben aus dem Formular',
                'xmlform-export-information': 'In das Textfeld muss das aussehen eines Abonnentens im XML-Style beschrieben werden.<br>Die Variablen auf der rechten Seite müssen hierbei als Platzhalter für die entsprechenden Werte benutzt werden.<br>Eine Variable kann kopiert werden, indem man auf sie klickt.',
                'pdfform-export-configuration': 'Konfiguration',
                'pdfform-export-preform': 'Vorgaben aus dem Formular',
                'formExport-sign': 'Unterschrift',
                'formExport-image': 'Bild',
                'formExport-logo': 'Logo',

                // ---- checkBehavior ----
                'behavior-destroy': 'Löschen versuchen order alles deaktivieren (versuchen Sie es in 14 Tagen erneut)', //sync the value with BehaviorService.execSingleBehavior().DAYS_TO_WAIT
                'behavior-update': 'Speichern',
                'behavior-deactivateOriginal': 'Original deaktivieren',
                'behavior-copy': 'Kopie erstellen',
                'behavior-privateNew': 'Kopie privat setzten',
                'behavior-copyAssociations': 'Beziehungen Kopieren',
                'behavior-createAssociations': 'Beziehungen erstellen',
                'behavior-deactivateNewAssociations': 'Neue Beziehungen deaktivieren',
                'behavior-deactivateOriginalAssociations': 'Alte Beziehungen deaktivieren',

                // ---- RegEx ----
                'regEx-iban' : 'DE[0-9]{20}',

                // ---- client ----
                'app-titel' : 'Mobile Address Picker',
                'app-version' : 'Version: ',
                'login_err_401': 'Geräte-Lizenz ist nicht mehr gültig, bitte loggen Sie sich erneut ein.',
                'login_err_411': 'Dienstleister hat keine Gerätelizenzen mehr verfügbar.',
                'login_err_403': 'Fehlerhafte Anmeldeinformationen',
                'login_err_404': 'Fehlerhafte Anmeldeinformationen',
                'login_err_410': 'Fehlerhafte Anmeldeinformationen',
                'login_err_412': 'Der Promoter hat keine Berechtigung mit der vorhandenen Geräte-Lizenz.\n Geräte Lizenz wird zurückgesetzt.',
                'login_err_423': 'Geräte-Lizenz bereit vergeben',
                'login_err_500': 'Interner Serverfehler! Wenden Sie sich bitte an den Administrator',
                'login_err_devname': 'Bitte geben sie einen Gerätenamen ein',
                'partnerSelector_noPartner': 'Ihnen sind keine Partner mit aktiven Formularen zugewiesen.',
                'partnerSelector_useNoLocation': 'Arbeiten ohne Standortangabe',
                'locationPartner_address': 'Adresse',
                'form-data-loading_title': 'Lade Formulardaten',
                'form-data-loading_content': 'Formulardaten werden geladen. Bitte haben Sie ein wenig Geduld.',
                'form-invalid': 'Eingabe nicht valide',
                'form-invalid-canvas': 'Bitte überprüfen Sie Ihre Unterschrift',
                'form-invalid-checkbox': 'Bitte akzeptieren sie die Bedingungen',
                'form-invalid-empty': 'Bitte füllen Sie das Feld aus',
                'form-input-address-invalid-zip': 'Diese Postleitzahl wird leider nicht unterstützt.',
                'form-input-address-invalid-street': 'Diese Straße wird leider nicht unterstützt',
                'form-input-address-invalid-city': 'Diese Stadt wird leider nicht unterstützt',
                'form-input-address-invalid-zip-no-digits': 'Bitte geben Sie 5 Zahlen als Postleitzahl an',
                'street-record-are-loading':'Lade Straßenverzeichnis',
                'street-record-are-loading_text' : 'Das Straßenverzeichnis wird geladen. Bitte haben Sie ein wenig Geduld.',
                'street-record-loading-error' : 'Fehler beim Laden des Straßenverzeichnisses.',
                'street-record-loading-old-possible' : 'Ein aktuelles Straßenverzeichnis konnte nicht geladen werden. Verwende stattdessen das Straßenverzeichnis aus letzter Sitzung.',
                'street-record-loading-old-not-possible' : 'Das Straßenverzeichnis konnte nicht geladen werden.',
                'formimageprovider-could-not-load-img' : 'Sie sind offline, das Bild-Element konnte nicht geladen werden.',
                'form-invalid-iban' : 'Bitte geben Sie eine valide IBAN ein.',
                'customer-duplicate' : 'Dieser Abschluss existiert bereits.',
                'saved-offline': 'Derzeit besteht keine Internetverbindung. Der Abschluss wurde gespeichert und wird bei einer aktiven Internetverbindung gesendet',

                // --- stats
                'stats-header-form' : 'Formulare',
                'stats-header-stats' : 'Statistiken',
                'daily-stats-header-stats' : 'Tagesstatistik',
                'stats-default-text' : 'Wählen Sie bitte ein Formular aus.',
                'stats-transactions-collected' : 'Datensätze die mit dem Gerät aufgenommen wurden:',
                'stats-transactions-saved' : 'Erfolgreiche Übertragung der Datensätze des Promoters:',
                'stats-transactions-epaper' : 'Davon E-Paper:',
                'stats-transactions-print': 'Davon Print:',
                'stats-not-ready-yet' : 'Die Statistiken können nicht angezeigt werden. Wählen Sie bitte zu erst einen Partner und einen Standort aus.',

                // --- address
                'postalCode' : 'Postleitzahl',
                'city' : 'Stadt',
                'street' : 'Straße',
                'houseNumber' : 'Hausnummer',
                'houseNumberExtra' : 'Zusatz',
                'print' : 'Print',
                'epaper' : 'E-Paper',

                // --- Telefon
                'vwmobile':'Mobil/Vorwahl',
                'vwfest':'Festnetz/Vorwahl',
                'mobiletel':'Mobil/Nummer',
                'festtel':'Festnetz/Nummer',
                'form-input-tel-vwmobile':'Mobil-Vorwahl',
                'form-input-tel-vwfest':'Festnetz-Vorwahl',
                'form-input-tel-mobiletel':'Mobil-Nummer',
                'form-input-tel-festtel':'Festnetz-Nummer',

                // --- Multichoice
                'form-input-multichoice':'Auswahlelement',
                'form-input-multichoice-multic':'Mehrfachantworten möglich',
                'form-input-multichoice-answer':'Antwortmöglichkeit',
                'form-input-multichoice-entry':'mit Benutzereingabe',

                // --- Raffle
                'form-input-raffle': 'Gewinnspielelement',
                'form-input-raffle-nAnswers': 'Anzahl der Antworten',
                'form-input-raffle-required': 'Bitte wählen Sie eines der Felder aus',
                'form-input-raffle-disableAddressCheckbox': 'Blendet Checkbox-Auswahl Print/E-Paper nach dem Adressblock aus.',
                'form-input-raffle-multiple': 'Mehrere Hacken zulassen',

                // --- MISC
                'Einwilligung': 'Einwilligung',
                'AGB': 'AGB',
                'Opt-In': 'Opt-In'
            }
        };
    }
}
